export function MegaphoneIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.79167 3.53345L7.875 3.53345L7.875 8.78345L3.79167 8.78345C2.66409 8.78345 1.75 7.86936 1.75 6.74178L1.75 5.57511C1.75 4.44753 2.66409 3.53345 3.79167 3.53345Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.875 3.53352L10.2237 2.22449C10.585 2.02311 11.026 2.02812 11.3826 2.23764C11.7393 2.44717 11.9583 2.82988 11.9583 3.24353L11.9583 9.07352C11.9583 9.48718 11.7393 9.86992 11.3826 10.0795C11.026 10.289 10.585 10.294 10.2237 10.0926L7.875 8.78352"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 8.76318L4.5887 11.4849C4.78162 11.9672 5.24876 12.2835 5.76823 12.2835V12.2835C6.18977 12.2835 6.58386 12.0744 6.82019 11.7253C7.05652 11.3763 7.10431 10.9327 6.94776 10.5413L6.24464 8.78351"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
